import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {TRACK_ACTION_PAYLOAD_KEY} from 'web-app/util/famlytics/action-tracking-constants';

const domain = 'CHILD_PROFILE/NEW_CONTACT';

export const {success: createContactSuccess} = createAction(
    `${domain}/CREATE_CONTACT`,
    (childId, name, relation, email, phone, roleId) => ({
        childId,
        name,
        relation,
        email,
        phone,
        roleId,
        [TRACK_ACTION_PAYLOAD_KEY]: {
            withLogin: roleId !== '',
        },
    }),
    (newContact, roleId) => ({newContact, roleId}),
);
